<template>
  <div :class="route.name" class="page-container h-100" data-testid="app-container">
    <VApp data-testid="v-app">
      <VMain id="app" data-testid="main-content">
        <RouterView />
      </VMain>
      <VSnackbar
        v-model="newAppIsAvailable"
        :timeout="-1"
        location="center"
        class="new-app-available"
        color="secondary"
        data-testid="new-app-snackbar"
      >
        <div class="content" data-testid="snackbar-content">
          {{ t("newAppText") }}
        </div>
        <template #actions>
          <VBtn data-testid="refresh-button" color="primary" @click="update">
            <VIcon>mdi-refresh</VIcon>
            {{ t("refresh") }}
          </VBtn>
        </template>
      </VSnackbar>
    </VApp>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const route = useRoute();
const newAppIsAvailable = ref(false);
const instance = getCurrentInstance().proxy;

onMounted(async () => {
  if (instance.$workbox) {
    instance.$workbox.addEventListener("waiting", () => {
      newAppIsAvailable.value = true;
    });
  }
});

const update = async () => {
  newAppIsAvailable.value = false;
  await instance.$workbox.messageSW({ type: "SKIP_WAITING" });
};
</script>

<style lang="scss">
button:focus {
  outline: 0;
}

a {
  color: $label-gray !important;
  text-decoration: none;
}

.new-app-available {
  .v-snack__wrapper {
    min-width: 400px;
    max-width: 600px;
  }

  .v-snack__action {
    width: 100%;
    margin: 0;
    .v-btn {
      margin: auto;
    }
  }
}

// Y.S 13/10/26 SVC 10.x met $dialog-elevation à 0 pour tous les dialogs. Ce panneau n'a pas de
// fond grisé (scrim: false), l'ombre est la seule chose qui le détache de la page.
.socio-side-panel {
  border-radius: 4px;
  box-shadow:
    0 11px 15px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0 24px 38px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0 9px 46px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
</style>

<i18n>
{
  "fr": {
    "refresh": "Rafraîchir",
    "newAppText": "Une nouvelle version de Rapsotec est disponible, veuillez cliquer sur rafraîchir."
  },
  "en": {
    "refresh": "Refresh",
    "newAppText": "A new version of Rapsotec is available, please click refresh."
  }
}
</i18n>
